// @flow
import React from 'react';
import {IntlProvider} from 'react-intl';
import {formatLocale} from '../../utils/localization';
import withLingua from '../withLingua/withLingua';

import type {LinguaProps} from '../withLingua/withLingua';

type OwnProps = {
    children: any
};

type Props = OwnProps & LinguaProps;

export const IntlWrapper = (props: Props) => {
    const {children, messages, locale, isLinguaLoading} = props;
    if (isLinguaLoading) {
        return null;
    }
    const intlLocale = formatLocale(locale);
    return (
        <IntlProvider
            locale={intlLocale}
            key={intlLocale}
            messages={messages}
            textComponent="span"
        >
            {children}
        </IntlProvider>
    );
};

export default withLingua({
    namespace: 'traveler/search',
    category: 'messages'
})(IntlWrapper);
